module.exports = __webpack_public_path__ + "static/media/chat-screen_3.662a3253.png";